import posthog from "posthog-js";

const saEvent = (eventName: string, properties?: Record<string, any>) => {
  if (window && window.sa_event) return window.sa_event(eventName, properties);
};

const posthogEvent = (eventName: string, properties?: Record<string, any>) => {
  posthog.capture(eventName, properties);
};

export { posthogEvent as trackEvent };
